import React from 'react';
import { Box } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import { useTranslation } from 'react-i18next';
import { StyledDetailContent } from './index.style';

const NotificationDetail = ({ notification, onClose }) => {
  const { t, i18n } = useTranslation();

  if (!notification) return null;

  const langContent =
    notification.rawContent?.[i18n.language] ||
    notification.rawContent?.vi ||
    {};

  return (
    <CommonDialog
      open
      onClose={onClose}
      title={t('notificationDetail')}
      disableAutoClose
      width="640px"
      contentComponent={
        <StyledDetailContent>
          <Box className="detail-title">{langContent.title || ''}</Box>
          <Box className="detail-body">{langContent.text || ''}</Box>
        </StyledDetailContent>
      }
      actionComponent={
        <CommonButton
          variant="contained"
          customStyle={{
            height: '40px',
            textTransform: 'none',
          }}
          onClick={onClose}
        >
          {t('gotIt')}
        </CommonButton>
      }
    />
  );
};

export default NotificationDetail;
